import React, { FC } from 'react';
import { SettingsCardsPageSkeleton } from '../settings/settingsSkeleton';

export const ECommerceConnectionsPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
export const ECommerceSetupPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
